import { AppDownloadCTACard } from "../components/ctaCards/AppDownloadCTACard";
import { NettlePurchaseCTACard } from "../components/ctaCards/NettlePurchaseCTACard";
import { ContactSupportCard } from "../components/managementCards/ContactSupportCard";
import { useAuth } from "../components/providers/AuthProvider";

function Home() {
  const { user, loading } = useAuth();

  // // Public query - works for everyone
  // const {
  //   data: publicData,
  //   isLoading: publicLoading,
  //   error: publicError,
  // } = api.test.publicQuery.useQuery(undefined, {
  //   retry: false,
  //   refetchOnWindowFocus: false,
  // });

  // // Protected query - only works when authenticated
  // const {
  //   data: protectedData,
  //   isLoading: protectedLoading,
  //   error: protectedError,
  // } = api.test.authQuery.useQuery(undefined, {
  //   retry: false,
  //   refetchOnWindowFocus: false,
  //   enabled: !!user, // Only run when user is authenticated
  // });

  if (loading) {
    return (
      <div className="w-full h-full flex flex-col grow bg-white rounded-2xl justify-center items-center">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-w-screen w-screen min-h-screen h-full flex flex-col bg-surface-one">
      <div className="flex-1 flex flex-col items-center justify-center px-2 py-2">
        <div className="w-full h-full flex flex-col grow bg-white rounded-2xl">
          {loading ? (
            <div className="w-full h-full flex flex-col grow bg-white rounded-2xl justify-center items-center">
              <div>Loading...</div>
            </div>
          ) : (
            <AuthenticatedScroll alreadyHasNettle={false} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;

function AuthenticatedScroll({
  alreadyHasNettle,
}: {
  alreadyHasNettle: boolean;
}) {
  return (
    <div className="grow max-w-4xl mx-auto flex flex-col md:items-center mt-8 mb-8 px-4 gap-4 md:gap-24 ">
      <div className="flex flex-col md:items-center md:justify-center ">
        <p className="text-sm uppercase text-brand-primary">
          One tool, many journeys
        </p>
        <p className="text-4xl text-foreground-primary md:text-center">
          Welcome to the Samphire
        </p>
        <p className="text-4xl font-bold text-foreground-primary md:text-center">
          {/* TODO: Add special font */}
          Health Experience
        </p>
      </div>
      <div className="flex flex-col lg:flex-row items-center justify-center gap-4">
        <AppDownloadCTACard />
        {!alreadyHasNettle ? <NettlePurchaseCTACard /> : <></>}
        <div className="md:hidden w-full">
          <ContactSupportCard />
        </div>
      </div>
    </div>
  );
}
